import {Theme} from '@mui/material';

import {greenColors, orangeColors} from '../../layouts/theme/designSystem';

export const getDocumentListStyles = (theme: Theme) => {
  return {
    container: {
      marginTop: '12px',
      paddingRight: '30px',
    },
    documentItem: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '6px 8px',
      borderRadius: '4px',
      backgroundColor: 'transparent',
      border: `1px solid ${orangeColors[3]}`,
      transition: 'all 0.2s ease',
      height: '100%',
      minHeight: '40px',
      '&:hover': {
        backgroundColor: orangeColors[4],
      },
      [theme.breakpoints.down('sm')]: {
        padding: '4px 6px',
        minHeight: '36px',
      },
    },
    documentInfo: {
      display: 'flex',
      alignItems: 'center',
      gap: '6px',
      flex: 1,
      minWidth: 0,
      [theme.breakpoints.down('sm')]: {
        gap: '4px',
      },
    },
    documentIcon: {
      fontSize: 21,
      color: orangeColors[70],
      flexShrink: 0,
      [theme.breakpoints.down('sm')]: {
        fontSize: 16,
      },
    },
    documentText: {
      flex: 1,
      minWidth: 0,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      color: greenColors[700],
      lineHeight: 1.2,
      fontSize: '0.75rem',
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.7rem',
      },
    },
    actionButtons: {
      display: 'flex',
      alignItems: 'center',
      gap: '2px',
      flexShrink: 0,
      [theme.breakpoints.down('sm')]: {
        gap: '1px',
      },
    },
    viewButton: {
      color: orangeColors[70],
      padding: '2px',
      minWidth: '24px',
      width: '24px',
      height: '24px',
      '&:hover': {
        color: orangeColors[100],
        backgroundColor: orangeColors[6],
      },
      [theme.breakpoints.down('sm')]: {
        minWidth: '20px',
        width: '20px',
        height: '20px',
        padding: '1px',
      },
    },
    deleteButton: {
      color: orangeColors[70],
      padding: '2px',
      minWidth: '24px',
      width: '24px',
      height: '24px',
      '&:hover': {
        color: orangeColors[100],
        backgroundColor: orangeColors[6],
      },
      [theme.breakpoints.down('sm')]: {
        minWidth: '20px',
        width: '20px',
        height: '20px',
        padding: '1px',
      },
    },
  };
};
